import React, { ReactNode } from 'react'

import { Select as AntSelect, SelectProps } from 'antd'
import { OptionProps } from 'antd/lib/select'

interface LabeledValue {
  key: string
  label: React.ReactNode
}

declare type T = string | string[] | number | number[] | LabeledValue | LabeledValue[]

interface CurrentSelectProps {
  defaultValue?: string[] | number[]
  disabled?: boolean
  value?: string[] | number[] | string | undefined
  mode?: 'multiple' | 'tags'
  size?: 'large' | 'small' | 'middle'
  placeholder?: string | ReactNode
  showSearch?: boolean
  children?: ReactNode
  className?: string
  id?: string
  open?: boolean
  dropdownMatchSelectWidth?: boolean
  onChange?: (value: any, option: React.ReactElement<any> | React.ReactElement<any>[]) => void
  filterOption?: boolean | ((inputValue: string, option: React.ReactElement<OptionProps>) => boolean)
  onBlur?: () => void
  onDropdownVisibleChange?: (open: boolean) => void
  options?: { label: string; value: string }[]
}

const Input: React.FC<CurrentSelectProps & SelectProps> = (props) => {
  return (
    <>
      <AntSelect {...props}>{props.children}</AntSelect>
    </>
  )
}

export default Input
